// Angular
import { Component, OnInit, ViewChild, Input, Output, EventEmitter, Inject, OnDestroy } from '@angular/core';

// Libraries
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

// Models
import { DynamicTableColumn } from '../../models/dynamic-table-column.model';
import { AppCleanup } from '../../models';

@Component({
	selector: 'dynamic-select-dialog',
	templateUrl: './dynamic-select-dialog.component.html',
	styleUrls: ['./dynamic-select-dialog.component.scss'],
})
export class DynamicSelectDialogComponent extends AppCleanup implements OnInit, OnDestroy {
	componentTitle: string;
	name: string;
	items: any[] = [];
	selectedItems: any[] = [];
	columnList: DynamicTableColumn[] = [];
	multiselect = true;
	action: string;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: { items: any[]; name: string; columnList: DynamicTableColumn[]; multiselect: boolean; action: string },
		private dialogRef: MatDialogRef<DynamicSelectDialogComponent>
	) {
		super();
	}

	ngOnInit() {
		this.name = this.data?.name;
		this.items = this.data?.items;
		this.columnList = this.data?.columnList;
		this.multiselect = this.data?.multiselect;
		this.action = this.data?.action || 'Add';
		this.componentTitle = this.multiselect ? 'Select items' : 'Select item';
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	submit() {
		const selectedValue = this.selectedItems; // If single select, it returns one item
		this.dialogRef.close(selectedValue);
	}
}
